import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import { StoryElement, WithLazy, Link } from "@quintype/components";
import Breadcrumb from "./../shared/breadcrumbs";
import { produce } from "immer";
import StoryMidPromotion from "../../storyMidContent";
import styles from "../text-story-page/styles.m.css";
import stylesVideo from "./styles.m.css";
import { PGAdwithAd, VikatanResponsiveContainer } from "../../../../rows/ad-free";
import Media from "react-media";
import Icon from "../../../../atoms/icon";
import { fetchvuuklegetCommentCount } from "../../../../../api";
import { humanizeDate } from "../../../../utils/time-format";
class VideoStory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: "F"
    };
    this.fetchCommentsCount = this.fetchCommentsCount.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
  }

  componentDidMount() {
    global.userPromise.catch(() => ({})).then(user => {
      user && this.setState({ userType: user.userType });
    });
    this.fetchCommentsCount();
  }

  fetchCommentsCount() {
    const storyId = this.props.story.id;
    fetchvuuklegetCommentCount(storyId)
      .then(res => {
        this.setState({ commentsCount: res.data });
      })
      .catch(error => {
        console.error("Error fetching comments count:", error);
      });
  }

  handleShowMore() {
    this.setState(prevState => ({
      showMore: !prevState.showMore
    }));
  }

  handleShareClick() {
    this.setState(prevState => ({
      showShare: !prevState.showShare
    }));
  }

  render() {
    const renderSidebar = get(this.props, ["renderSidebar"], () => null);
    const renderHeaderCard = get(this.props, ["renderHeaderCard"], () => null);
    const renderarticleFooter = get(this.props, ["renderarticleFooter"], () => null);
    const renderFooter = get(this.props, ["renderFooter"], () => null);
    const renderSocialMedia = get(this.props, ["renderSocialMedia"], () => null);
    const storyHeadline = get(this.props, ["story", "subheadline"], () => null);
    const section = get(this.props, ["story", "sections", "0"], null);
    const cards = get(this.props, ["story", "cards"], []);
    const story = get(this.props, ["story"], () => null);
    const storyId = get(this.props, ["story", "id"], "");
    const { userType } = this.state;
    const { commentsCount, showShare } = this.state;
    const readMore = false;

    const expandComments = get(this.props, ["expandComments"], () => null);

    let firstVideoElement;
    let firstVideoCard = {};

    for (let cardIterator = 0; cardIterator < cards.length; cardIterator++) {
      const foundVideo = cards[cardIterator]["story-elements"].find(
        ({ type, subtype }) => type === "youtube-video" || (type === "jsembed" && subtype === "dailymotion-video")
      );
      if (foundVideo) {
        firstVideoElement = foundVideo;
        firstVideoCard = cards[cardIterator];
        break;
      }
    }

    const renderHeaderVideo = () => {
      if (!firstVideoElement) {
        return null;
      }

      return (
        <div className={stylesVideo["header-video"]}>
          <StoryElement
            element={firstVideoElement}
            card={firstVideoCard}
            key={firstVideoElement.id}
            story={this.props.story}
          />
        </div>
      );
    };

    const scrollToComments = () => {
      expandComments();
      const commentsWidgetContainer = document.getElementById("commentsWidgetContainer");
      if (commentsWidgetContainer) {
        commentsWidgetContainer.scrollIntoView({ behavior: "smooth" });
      }
    };

    return (
      <div className="page-content">
        <div className={`container ${styles["story-grid"]}`}>
          <div className={styles["main-content"]}>
            <article className={`${styles["story-body"]} ${stylesVideo["story-body"]} js-story`}>
              <Breadcrumb subSection={section} config={this.props.config} />
              <WithLazy margin="300px">
                {() => (
                  <div className="vikatan-top-ad-width ad">
                    <div className="ad-container vikatan-top-ad">
                      <Media query="(max-width:768px)">
                        {matches =>
                          matches ? (
                            <div
                              className={`mobile ${
                                userType === "P" || userType === "T" || userType === "R" ? "" : "ad_300_100"
                              }`}
                            >
                              <PGAdwithAd
                                adId={`Vikatan2023_Mobile_SP_TOP_320x100`}
                                adSize={[[320, 100]]}
                                minHeight={100}
                                adDivId="div-ad-desk-3849069-9810-0"
                                class="ad-320x100"
                                story={this.props.story}
                              />
                            </div>
                          ) : null
                        }
                      </Media>
                    </div>
                  </div>
                )}
              </WithLazy>
              {renderHeaderCard("", true, true, true)}

              <p className={`${styles["subheadline"]} subheadline-main`}>{storyHeadline}</p>
              <div className={styles["published-time-wrap"]}>
                {story["first-published-at"] && (
                  <span className={styles["published"]}>
                    Published:
                    <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                      {humanizeDate(story["first-published-at"], "relative")}
                    </time>
                  </span>
                )}
                {story["last-published-at"] && (
                  <span className={styles["updated"]}>
                    Updated:
                    <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                      {humanizeDate(story["last-published-at"], "relative")}
                    </time>
                  </span>
                )}
              </div>
              {renderHeaderVideo()}
              <div className={styles["audio-share-wrapper"]}>
                <div className={styles["audio-comments-share"]}>
                  <div>
                    <Link
                      href="https://whatsapp.com/channel/0029Va7F0Hj0bIdoYCCkqs41"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles["box-div"]}
                    >
                      <Icon type="icon-whatsapp" className={styles["whatsapp-channel-icon"]} />
                      <span className={styles["channel-txt"]}>Join Our Channel</span>
                    </Link>
                    {/* <Link
                      href="https://bit.ly/3J0OoJc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${styles["box-div"]} ${styles["play-to-win"]}`}
                      style={{ padding: "0" }}
                    >
                      <img src="https://media.vikatan.com/vikatan/2024-03/2455867c-ef84-491e-be25-abd7a1e00de2/Play_to_win.gif" />
                    </Link> */}
                  </div>

                  <div className={styles["box-div"]} onClick={scrollToComments}>
                    <Icon type="comment" />
                    <span className={styles["channel-txt"]}>{commentsCount && commentsCount[storyId]}</span>
                    <span className={`${styles["channel-txt"]} hidden-mobile`}>Comments</span>
                  </div>
                  <div
                    className={`${styles["box-div"]} ${showShare ? styles["share-active"] : ""} `}
                    onClick={this.handleShareClick}
                  >
                    <Icon type="socialshare" />
                    <span className={`${styles["channel-txt"]} hidden-mobile`}>Share</span>
                  </div>
                </div>
                <div className={styles["social-share-wrapper"]}>
                  {showShare && !readMore && renderSocialMedia("", false)}
                </div>
              </div>

              {this.props.story.cards.map((card, index) => {
                const newCard = produce(card, draft => {
                  draft["story-elements"] = draft["story-elements"].filter(
                    element => element.id !== get(firstVideoElement, ["id"], "")
                  );
                });
                return (
                  <React.Fragment key={newCard.id}>
                    <VikatanResponsiveContainer
                      placement={"video-story"}
                      adtype={parseInt(index + 1)}
                      storyId={storyId}
                      className="ad_300_250"
                      story={this.props.story}
                    />
                    {index === 1 && <StoryMidPromotion story={this.props.story} />}
                    <StoryCard card={newCard} story={this.props.story} config={this.props.config} />
                  </React.Fragment>
                );
              })}

              <div id="commentsWidgetContainer">{renderarticleFooter()}</div>
            </article>
            {renderFooter()}
          </div>
          {renderSidebar()}
        </div>
      </div>
    );
  }
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
VideoStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { VideoStory };
